import {SystemColumnType} from "../../../../manager/columns/types"
import {FieldGroup} from "../../../../../fields/@group"
import {ColumnsConfigGroup} from "../../../../../model2/column/@types";

// here we store all columns we can add in groups (add field, pr preferences use this)

const ColumnsGroups_V2: ColumnsConfigGroup[] = []

ColumnsGroups_V2.push({
    id          : FieldGroup.MAIN,
    columnsIds  : [
        SystemColumnType.PROJECT,
        SystemColumnType.PROJECT_PATH,

        SystemColumnType.TASK_ID,
        SystemColumnType.TITLE,
        SystemColumnType.STATUS,
        SystemColumnType.PRIORITY,
        SystemColumnType.TASK_TYPE,
        'separator',
        // FIELDS.type.DEPENDS_ON,
        // FIELDS.type.DEPENDANTS,
        // 'separator',
        SystemColumnType.TAGS,
        SystemColumnType.OPEN_ALL,
        SystemColumnType.COMMENTS,
        SystemColumnType.PROJECT_COLOR,
        SystemColumnType.PROJECT_HEALTH,
        SystemColumnType.DESCRIPTION,
        SystemColumnType.MESSAGES_TOTAL,
        SystemColumnType.ATTACHMENTS_TOTAL,
        SystemColumnType.TODO_LIST,
        SystemColumnType.BASELINE,
        SystemColumnType.COVER,
        SystemColumnType.IS_BILLABLE,
    ]
})

ColumnsGroups_V2.push({
    id          : FieldGroup.USERS,
    columnsIds  : [
        SystemColumnType.ACTION_REQUIRED,
        SystemColumnType.ASSIGNED_TO,
        SystemColumnType.CREATED_BY,
        SystemColumnType.USERS,
        SystemColumnType.OWNER
    ]
})

ColumnsGroups_V2.push({
    id          : FieldGroup.DATES,
    columnsIds  : [
        SystemColumnType.START_END_DATE,
        SystemColumnType.DEADLINE,
        SystemColumnType.SCHEDULE,
        SystemColumnType.START_DATE,
        SystemColumnType.END_DATE,
        'separator',
        SystemColumnType.DURATION_CALENDAR_DAYS,
        SystemColumnType.DURATION_WORK_DAYS,
        'separator',
        SystemColumnType.LAST_UPDATED,
        SystemColumnType.DATE_CREATED,
        SystemColumnType.DATE_CLOSED,
        SystemColumnType.TASK_LEAD_TIME,
        SystemColumnType.TASK_AGE
    ]
})

const estimateFields = [
    SystemColumnType.ESTIMATE,
    SystemColumnType.PROJECT_ESTIMATE,
    SystemColumnType.PROJECT_ESTIMATE_TASKS,
]

if (gd.modules.storyPoints.enabled) {
    estimateFields.push(SystemColumnType.STORY_POINTS)
}

ColumnsGroups_V2.push({
    id          : FieldGroup.ESTIMATE,
    showIcons   : true,
    columnsIds  : estimateFields
})

ColumnsGroups_V2.push({
    id          : FieldGroup.TIME,
    showIcons   : true,
    columnsIds  : [
        // FIELDS.type.ESTIMATE,
        SystemColumnType.TIME_REPORTED,
        SystemColumnType.SPENT_ESTIMATE,
        'separator',
        SystemColumnType.PROGRESS_BAR,
        SystemColumnType.PROGRESS_ITEMS,
        SystemColumnType.PROGRESS_TASKS,
        SystemColumnType.START_END_MOMENT
    ]
})

ColumnsGroups_V2.push({
    id          : FieldGroup.DEPENDENCIES,
    columnsIds  : [
        SystemColumnType.DEPENDS_ON,
        SystemColumnType.DEPENDANTS,
    ]
})

ColumnsGroups_V2.push({
    id          : FieldGroup.FINANCE,
    showIcons   : false,
    columnsIds  : [
        SystemColumnType.COST_INTERNAL,
        SystemColumnType.COST_EXTERNAL,
        SystemColumnType.ESTIMATED_COST_INTERNAL,
        SystemColumnType.ESTIMATED_COST_EXTERNAL,
        SystemColumnType.COST_EXPENSES,
        SystemColumnType.ITEM_MODEL_CALCULATED_EXPENSES
    ]
})

if (gd.modules.crm.enabled) {
    ColumnsGroups_V2.push({
        id          : FieldGroup.CRM,
        showIcons   : true,
        columnsIds  : [
            SystemColumnType.CRM_ACCOUNT,
            SystemColumnType.CRM_CONTACTS
        ]
    })
}

ColumnsGroups_V2.push({
    id: FieldGroup.CUSTOM_FIELDS
})

export default ColumnsGroups_V2

